import React, {useState} from "react";
import {Link} from "react-router-dom";
import {Checkbox, message, Input} from "antd";
import {EyeInvisibleOutlined, EyeTwoTone} from '@ant-design/icons';

import axios from 'axios';

import InputField from "../input/InputField";
import LogoWithTitle from "../lt/lt";
import config from '@/config'
import FadeInWhenVisible from "@/components/animations/FadeInWhenVisible";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faFacebook, faGoogle} from "@fortawesome/free-brands-svg-icons";
import {faPhone} from "@fortawesome/free-solid-svg-icons";

const Login = () => {


    const [messageApi, contextHolder] = message.useMessage();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");

    const handleRemember = () => {
        console.log("Remember me");
    }
    const Checkform = () =>{
        if(email.length < 1) {
            messageApi.open({
                type: 'error',
                content: 'Vui lòng không bỏ trống tài khoản',
            });
            return false;
        }
        if(password.length < 1) {
            messageApi.open({
                type: 'error',
                content: 'Vui lòng không bỏ trống mật khẩu',
            });
            return false;
        }
    }

    const handleLogin = async (username,password) => {
        try{
            const res = await axios.post('/api/User/Login', {
                username : username,
                password : password
            });

            if(res.data.success) {
                alert("Đăng nhập thành công");
                localStorage.setItem("user", JSON.stringify(res.data.token));
            }else{
                alert("Đăng nhập thất bại");
            }
        }catch(err) {
            console.log(err);
        }
    }
    return (
        <FadeInWhenVisible>
            <div className="flex flex-1 flex-col justify-center px-6 py-6 lg:px-8">
                <LogoWithTitle
                    src="/img/logo_TinViet2.jpg"
                    alt="Your Company"
                    title="Đăng nhập"
                />

                <div className="mt-2 sm:mx-auto sm:w-full sm:max-w-sm">
                    <form name={"login_form"} encType={"multipart/form-data"} onSubmit={Checkform} method="POST" className="space-y-3">
                        <InputField
                            id="email"
                            name="email"
                            type="email"
                            label="Tài khoản Email"
                            autoComplete="email"
                            placeholder="Nhập email"
                            onChange={(e) => setEmail(e.target.value)}
                        />
                        <div className={""}>
                            <label htmlFor="password" className="block text-sm/6 font-medium text-gray-900">Mật
                                khẩu</label>
                            <Input.Password
                                id="password"
                                rootClassName={"mt-2 p-2 relative"}
                                placeholder="Nhập mật khẩu"
                                iconRender={(visible) => (visible ? <EyeTwoTone/> : <EyeInvisibleOutlined/>)}
                            />
                        </div>
                        <div>
                            <div className="flex justify-between">
                                <Checkbox onChange={() => handleRemember()}>Nhớ tài khoản</Checkbox>
                                <Link to={config.routes.forgotPassword}
                                      className="font-semibold text-green-600 hover:text-green-500">
                                    Quên mật khẩu
                                </Link>
                            </div>
                            {contextHolder}
                            <button
                                type="submit"
                                className="mt-2 flex w-full justify-center rounded-md bg-green-500 px-3 py-1.5 text-sm/6 font-semibold text-white shadow-sm hover:bg-green-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-green-600">
                                Đăng nhập
                            </button>
                        </div>
                    </form>
                    <p className="mt-2 text-center text-sm/6 text-gray-500">
                        Chưa có tài khoản{' '}
                        <Link to={config.routes.registerCandidate}
                              className="font-semibold text-green-600 hover:text-green-500">
                            Đăng ký ngay
                        </Link>
                    </p>
                    <p className="mt-2 text-center text-sm/6 text-gray-500">
                        Hoặc đăng nhập với{''}
                    </p>
                    <div className="flex justify-center fa-align-center mt-4">
                        <Link to={"/dang-nhap/sso/google"} className={"px-8 py-4 items-center flex text-3xl font-bold shadow-lg me-2 bg-gray-100 rounded-xl transition-all hover:bg-gray-300"}>
                            <FontAwesomeIcon icon={faGoogle} className={"text-red-500"} />
                        </Link>
                        <Link to={"/dang-nhap/sso/google"} className={"px-8 py-4 items-center flex text-3xl font-bold shadow-lg me-2 bg-gray-100 rounded-xl transition-all hover:bg-gray-300"}>
                            <FontAwesomeIcon icon={faFacebook} className={"text-indigo-500"} />
                        </Link>
                        <Link to={"/dang-nhap/sso/google"} className={"px-8 py-4 items-center flex text-3xl font-bold shadow-lg me-2 bg-gray-100 rounded-xl transition-all hover:bg-gray-300"}>
                            <FontAwesomeIcon icon={faPhone} className={"text-green-500"} />
                        </Link>
                    </div>
                </div>
            </div>
        </FadeInWhenVisible>
    )
}

export default Login;